(() => {
  if (customElements.get('goondi-hero')) return;
  class GoondiHero extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('.ghs-slide')];
      this.dots = [...this.querySelectorAll('.ghs-dot')];
      this.toggle = this.querySelector('.ghs-toggle');
      this.current = 0;
      this.delay = Math.max(5000, Number(this.dataset.speed) || 7000);
      this.autoplay = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.editorPaused = false;
      this.hovered = false;
      this.focused = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('.ghs-arrow--prev')?.addEventListener('click', () => this.show(this.current - 1), options);
      this.querySelector('.ghs-arrow--next')?.addEventListener('click', () => this.show(this.current + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      let touch;
      this.addEventListener('touchstart', event => {
        if (event.touches.length === 1) touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!touch) return;
        const dx = touch.x - event.changedTouches[0].clientX;
        const dy = touch.y - event.changedTouches[0].clientY;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.current + (dx > 0 ? 1 : -1));
        touch = null;
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', () => { this.updateToggle(); this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorPaused = true;
        this.show(index);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
        this.editorPaused = false;
        this.schedule();
      }, options);
      this.classList.add('is-ready');
      this.updateToggle();
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
    updateToggle() {
      if (!this.toggle) return;
      this.toggle.hidden = !this.autoplay || this.reducedMotion.matches;
      this.toggle.setAttribute('aria-pressed', String(this.userPaused));
      this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      this.toggle.querySelector('[data-pause]').hidden = this.userPaused;
      this.toggle.querySelector('[data-play]').hidden = !this.userPaused;
    }
    show(index) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.current);
        if (i === this.current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const counter = this.querySelector('[data-current]');
      if (counter) counter.textContent = String(this.current + 1).padStart(2, '0');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplay || this.slides.length < 2 || this.userPaused || this.editorPaused || this.hovered || this.focused || document.hidden || this.reducedMotion.matches) return;
      this.timer = setTimeout(() => this.show(this.current + 1), this.delay);
    }
  }
  customElements.define('goondi-hero', GoondiHero);
})();
